import { Filter, ShoppingBag, Users } from "lucide-react"
import { Button } from "../ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs"
import { InteractionHistoricTableComponent } from "./InteractionHistoricTableComponent"
import { ShopHistoricTableComponent } from "./ShopHistoricTable"

type HistoricTabsProps = {
  activeTab: string
  onTabChange: (value: string) => void
  searchTerm: string
  selectedActionType: string
  onOpenFilters: () => void
  onResetFilters: () => void
}

export const HistoricTabs = ({
  activeTab,
  onTabChange,
  searchTerm,
  selectedActionType,
  onOpenFilters,
  onResetFilters,
}: HistoricTabsProps) => {
  return (
    <Card className="flex-1 flex flex-col">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Historique des actions</CardTitle>
            <CardDescription>
              {activeTab === "boutique"
                ? "Liste chronologique des modifications apportées à votre boutique"
                : "Liste chronologique des actions des prestataires"}
            </CardDescription>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={onOpenFilters}
            className="flex items-center gap-2"
          >
            <Filter className="h-4 w-4" />
            Filtres
          </Button>
        </div>
      </CardHeader>
      <CardContent className="flex-1 overflow-auto">
        <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="boutique" className="flex items-center">
              <ShoppingBag className="h-4 w-4 mr-2 text-blue-600" />
              Boutique
            </TabsTrigger>
            <TabsTrigger value="prestataires" className="flex items-center">
              <Users className="h-4 w-4 mr-2 text-orange-600" />
              Prestataires
            </TabsTrigger>
          </TabsList>

          <TabsContent value="boutique" className="space-y-4 mt-6">
            <ShopHistoricTableComponent
              searchTerm={searchTerm}
              selectedActionType={selectedActionType}
              onResetFilters={onResetFilters}
            />
          </TabsContent>

          <TabsContent value="prestataires" className="space-y-4 mt-6">
            <InteractionHistoricTableComponent
              searchTerm={searchTerm}
              selectedActionType={selectedActionType}
              onResetFilters={onResetFilters}
            />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  )
}
